/**
 * WEB-3956 юнит 8 — раздел маршрутов «документы»: собственные юридические
 * документы продукта. Собирает `router/index.tsx` (в роутер апекса).
 */
import type { RouteObject } from 'react-router-dom';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { FirstSuspense } from '../suspense';

// WEB-1288: собственные юридические документы продукта. Человек открывает их
// с формы регистрации ДО входа, поэтому они живут рядом с auth-страницами.
const TermsPage = lazyWithRetry(() => import('@/pages/Terms'), 'page:Terms');
const PrivacyPage = lazyWithRetry(() => import('@/pages/Privacy'), 'page:Privacy');
// WEB-2162 п.1: отдельный документ «Данные о здоровье» — требование закона
// штата Вашингтон (My Health My Data), самостоятельная страница, а не раздел
// политики.
const HealthDataPage = lazyWithRetry(() => import('@/pages/HealthData'), 'page:HealthData');

// WEB-1288: «Условия использования» и «Политика конфиденциальности» — те
// самые документы, которые человек ОБЯЗАН принять при регистрации. До этой
// правки маршрутов не было, и обе ссылки формы доставались перехватчику
// коротких адресов квизов ('/:quizSlug' в публичном разделе) — человек видел
// «квиз не найден» вместо документа. Литеральные маршруты react-router
// оценивает выше одиночного параметра, поэтому перехватчик их не съедает;
// слова 'terms' и 'privacy' тем самым становятся зарезервированными (см.
// RESERVED_APEX_PATH_SEGMENTS в utils/publicHost.ts). Сторож —
// router/registerLegalLinks.web1288.guard.test.ts.
export const LEGAL_ROUTES: RouteObject[] = [
  {
    path: '/terms',
    element: <FirstSuspense><TermsPage /></FirstSuspense>,
  },
  {
    path: '/privacy',
    element: <FirstSuspense><PrivacyPage /></FirstSuspense>,
  },
  {
    path: '/health-data',
    element: <FirstSuspense><HealthDataPage /></FirstSuspense>,
  },
];
